import { render, staticRenderFns } from "./Block1.vue?vue&type=template&id=4bc158b4&scoped=true"
import script from "./Block1.vue?vue&type=script&lang=js"
export * from "./Block1.vue?vue&type=script&lang=js"
import style0 from "./Block1.vue?vue&type=style&index=0&id=4bc158b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc158b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc158b4')) {
      api.createRecord('4bc158b4', component.options)
    } else {
      api.reload('4bc158b4', component.options)
    }
    module.hot.accept("./Block1.vue?vue&type=template&id=4bc158b4&scoped=true", function () {
      api.rerender('4bc158b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Block1.vue"
export default component.exports